import React from 'react';
import NoContent from 'components/ui/noContent';
import { useTranslation } from 'hooks';
import './errorFallback.scss';

export const ErrorFallback = () => {
  const getTranslate = useTranslation();
  return (
    <div className='error-boundary'>
      <NoContent text={getTranslate('common.sectionError.text')} />
    </div>
  );
};
